import React, { Component } from "react";
import { FiChevronDown } from "react-icons/fi";
import AccountsModal from "../../../base/features/blocks/AccountsModal";
import Image from "../../../base/features/micro/Image";
import Spinner from "../../../base/features/micro/Spinner";
import { accounts } from "../../../base/services/services";
import { fixObject } from "../../../base/utils/convert_to_object";
import DynamicView from "../../dynamicView/DynamicView";
import ManagementNavBottom from "../blocks/ManagementNavBottom";
import Header from "./blocks/Header";
import { account } from "./services";

class DashBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account: null,
      shopUid: window.location.pathname.split("/")[2],
      accounts_modal: false,
      accounts: null,
      selectedAccount: {},
      user: null,
    };
  }
  componentDidMount() {
    this.getAccount();
    this.checkAccountsModal();
  }
  checkAccountsModal() {
    let accounts =
      window.location.search && fixObject(window.location.search).accounts;
    if (accounts && Number(accounts) === 1) {
      this.setState({ accounts_modal: true });
      this.get_accounts();
    }
  }
  getAccount() {
    account(this.state.shopUid).then((items) => {
      if (items) {
        localStorage.setItem("selected_shop", JSON.stringify(items));
        this.setState({ account: items });
      }
    });
  }
  get_accounts() {
    accounts().then((items) => {
      if (items) {
        this.setState({
          accounts: items.shops,
          user: items.user,
        });
      }
    });
  }

  render() {
    return (
      <div className="container-fluid px-0">
        <Header />
        {this.state.account ? (
          <body>
            <div className="row mx-0 px-3 pb-3">
              <div className="col-auto align-self-center">
                <Image
                  imageHeight={"70"}
                  imageWidth={"70"}
                  imgClassName={"rounded-circle img-cover"}
                  extraClassName={"rounded-circle bg-color-main p-2"}
                  imageAlt={"avatar"}
                  imageUri={
                    this.state.account.cover &&
                    this.state.account.cover.thumbnail
                  }
                />
              </div>
              <div className="col align-self-center">
                <p
                  className="mb-0 fs-3 fw-bold"
                  onClick={() => {
                    this.setState({ accounts_modal: true });
                    this.get_accounts();
                  }}
                >
                  {this.state.account.title}
                  <FiChevronDown size={26} className="me-2" />
                </p>
                <p className="mb-0 text-muted fw-bold">
                  {this.state.account.call_center}
                </p>
              </div>
            </div>
            <div className="px-0" style={{ marginBottom: "90px" }}>
              <DynamicView viewPage="dashboard" />
            </div>
          </body>
        ) : (
          <Spinner />
        )}
        {this.state.accounts_modal && (
          <AccountsModal
            changeModal={(value) => this.setState({ accounts_modal: value })}
            accounts_modal={this.state.accounts_modal}
            accounts={this.state.accounts}
            user={this.state.user}
          />
        )}
        <ManagementNavBottom />
      </div>
    );
  }
}

export default DashBoard;
